import { ComponentPropsWithoutRef } from "react";
import cn from "../../../util/cn";

type TableLegendProps = ComponentPropsWithoutRef<"div">;

const DiabetesTableLegend = ({ className, ...otherProps }: TableLegendProps) => (
  <div className={cn("flex w-fit items-center gap-4 text-sm", className)} {...otherProps}>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-emergency" />
      Emergency low
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-warning" />
      Critical low
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-acceptable" />
      Low
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-acceptable" />
      Acceptable
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-warning" />
      Elevated
    </div>
    <div className="flex w-fit items-center">
      <ColorIndicator className="bg-measurement-text-emergency" />
      Critical high
    </div>
  </div>
);

type ColorIndicatorProps = ComponentPropsWithoutRef<"span">;

const ColorIndicator = ({ className, ...otherProps }: ColorIndicatorProps) => (
  <span
    className={cn("print-color-exact me-1 inline-block size-2 border p-1", className)}
    {...otherProps}
  />
);

export default DiabetesTableLegend;
